/**
 * TooltipsContent - The content of Tooltips by id
 */
import React from "react"
import { TippyUL, TippyLI } from "./styles"

export const Tooltips = {
  location: (
    <div>
      <div className={"tippy-title"}>Location</div>
      <div className={"tippy-content"}>
        <p>Please provide a FULL postcode e.g. NW10 3EG</p>
      </div>
    </div>
  ),
  socialMobilityStatus: (
    <div>
      <div className={"tippy-title"}>Social mobility status</div>
      <div className={"tippy-content"}>
        <p>One flag or more indicates a measure of social disadvantage.</p>
      </div>
    </div>
  ),
  socialMobilityMetricsOZ: (
    <div>
      <div className={"tippy-title"}>Social mobility metrics</div>
      <div className={"tippy-content"}>
        <p>Measures of socioeconomic and personal disadvantage </p>
      </div>
    </div>
  ),
  customQuestions: (
    <div>
      <div className={"tippy-title"}>Application questions</div>
      <div className={"tippy-content"}>
        Search for your question and then select the responses you would like to
        filter on.
      </div>
    </div>
  ),
  socialMobilityMetrics: (
    <div>
      <div className={"tippy-title"}>Social mobility metrics</div>
      <div className={"tippy-content"}>
        <p>Measures of socioeconomic and personal disadvantage, including: </p>
        <p>
          First generation - indicates that the candidate's parents did not
          attend university.
        </p>
        <p>
          Disadvantaged postcode - indicates whether the candidate lived in an
          area of social disadvantage at age 16.
        </p>
      </div>
    </div>
  ),
  assessmentScore: (
    <div>
      <div className={"tippy-title"}>Assessment score</div>
      <div className={"tippy-content"}>
        <p>Filter candidates based on score received at this stage.</p>
      </div>
    </div>
  ),
  ks5CompletionYear: (
    <div>
      <div className={"tippy-title"}>KS5 completion year</div>
      <div className={"tippy-content"}>
        <p>
          The year in which the candidate completed their age 16-18
          qualifications.
        </p>
      </div>
    </div>
  ),
  ks5SchoolPI: (
    <div>
      <div className={"tippy-title"}>KS5 PI</div>
      <div className={"tippy-content"}>
        <p>
          PI means Performance Index. This can help identify candidates who have
          performed above the average at their specific school. E.g. Jim
          attended a school where the average was BCC at A Level. Jim achieved
          ABB. His Performance Index was +14%. A significant PI is +30% or
          above. An exceptional PI is +48% or above.
        </p>
      </div>
    </div>
  ),
  ks4SchoolPI: (
    <div>
      <div className={"tippy-title"}>KS4 PI</div>
      <div className={"tippy-content"}>
        <p>
          KS4 PI means Key Stage 4 Performance Index. This can help identify
          candidates who have performed above the average at their specific
          school in their KS4 examinations. A significant KS4 PI is +30% or
          above. An exceptional KS4 PI is +48% or above.
        </p>
      </div>
    </div>
  ),
  ks5SchoolPIOZ: (
    <div>
      <div className={"tippy-title"}>PI</div>
      <div className={"tippy-content"}>
        <p>
          PI means Performance Index. This can help identify candidates who have
          performed above the average at their specific school.
        </p>
      </div>
    </div>
  ),
  ks5Grades: (
    <div>
      <div className={"tippy-title"}>KS5 grades - A levels (or equivalent)</div>
      <div className={"tippy-content"}>
        <p>
          Search for candidates with certain grades or above. E.g. select "AAA"
          from the dropdown to search for candidates with three As or better at
          A level or equivalent. Candidates with equivalent grades in the
          International Baccalaureate, Pre-U, Scottish Highers and Advanced
          Highers will also be included in your results.
        </p>
      </div>
    </div>
  ),
  ks5SchoolPercentile: (
    <div>
      <div className={"tippy-title"}>KS5 school percentile</div>
      <div className={"tippy-content"}>
        <p>
          An indicator of school quality. The higher the percentile, the better
          the school.
        </p>
      </div>
    </div>
  ),
  ks4CompletionYear: (
    <div>
      <div className={"tippy-title"}>KS4 completion year</div>
      <div className={"tippy-content"}>
        <p>
          The year in which the candidate completed their age 14-16
          qualifications.
        </p>
      </div>
    </div>
  ),
  ks4SchoolPercentile: (
    <div>
      <div className={"tippy-title"}>KS4 school percentile</div>
      <div className={"tippy-content"}>
        <p>
          An indicator of school quality. The higher the percentile, the better
          the school.
        </p>
      </div>
    </div>
  ),
  ks4Grades: (
    <div>
      <div className={"tippy-title"}>KS4 grades - GCSEs (or equivalent)</div>
      <div className={"tippy-content"}>
        <p>
          Search for candidates with certain grades or above. E.g. select the
          grade "A/7" and the amount "5" from the dropdowns to find candidates
          with at least 5 A/7 grades at GCSE or equivalent. Candidates with
          equivalent grades in National 5s or Standards will also be included in
          your results.
        </p>
      </div>
    </div>
  ),
  universityPIs: (
    <div>
      <div className={"tippy-title"}>University PIs</div>
      <div className={"tippy-content"}>
        <p>
          PI means Performance Index. This can help identify candidates who have
          performed above the average at their specific university. For example,
          Jim studied Law at Durham University. The average final degree score
          for his course, in his specific year of graduation was 60%. Jim's
          score was 70%. His degree PI was therefore +17%. You can search by
          overall degree PI, PI for a specific year, or (for Law only) PI by
          specific module.
        </p>
      </div>
    </div>
  ),
  interviewBcc: (
    <div>
      <div className={"tippy-title"}></div>
      <div className={"tippy-content"}>
        <p>Copy the meeting invitation into a shared or team calendar.</p>
      </div>
    </div>
  ),
  groupDetailsSearch: (
    <div>
      <div className={"tippy-content"}>
        <p>Find new candidates who meet the search criteria for this group.</p>
      </div>
    </div>
  ),
  CovidMarker: (
    <div>
      <div className={"tippy-title"}>COVID-19</div>
      <div className={"tippy-content"}>
        <p>
          This candidate’s educational attainment may have been affected by
          COVID-19.
        </p>
      </div>
    </div>
  ),

  // ************************************************
  // ********** REPORTING TOOLTIP CONTENTS **********
  // ************************************************
  CONTEXTUALSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Contextual report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Total CRS flags</TippyLI>
            <TippyLI>CRS flag type</TippyLI>
            <TippyLI>Performance Index</TippyLI>
            <TippyLI>School percentile</TippyLI>
            <TippyLI>Social mobility metrics</TippyLI>
            <TippyLI>CRS adjustment</TippyLI>
            <TippyLI>Parental occupation</TippyLI>
            <TippyLI>CRS opt-in rates</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITYSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>1+ flags</TippyLI>
            <TippyLI>Disability</TippyLI>
            <TippyLI>Sexual orientation</TippyLI>
            <TippyLI>Transgender status</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITYSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>Diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Sex</TippyLI>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>Religion</TippyLI>
            <TippyLI>Sexual orientation</TippyLI>
            <TippyLI>Transgender status</TippyLI>
            <TippyLI>Disability status</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITYINTERSECTIONAL: (
    <div>
      <div className={"tippy-title"}>Intersectional diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Gender and ethnicity</TippyLI>
            <TippyLI>Gender and socioeconomic status</TippyLI>
            <TippyLI>Ethnicity and socioeconomic status</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  EFFICIENCYSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Efficiency report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>App to interview ratio</TippyLI>
            <TippyLI>Interview to offer ratio</TippyLI>
            <TippyLI>Offer to acceptance ratio</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  EFFICIENCYSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>Efficiency report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>App to interview ratio</TippyLI>
            <TippyLI>Interview to offer ratio</TippyLI>
            <TippyLI>Offer to acceptance ratio</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  AGENCY_LATERALSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Agency report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Source</TippyLI>
            <TippyLI>Agency performance</TippyLI>
            <TippyLI>Costs</TippyLI>
            <TippyLI>Diversity</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITY_LATERALSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>Social mobility</TippyLI>
            <TippyLI>Sexual orientation</TippyLI>
            <TippyLI>Transgender status</TippyLI>
            <TippyLI>Disability status</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  MARKETING_LATERALSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Marketing report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>How did you hear about us</TippyLI>
            <TippyLI>Referrals</TippyLI>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>Disability status</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  EFFICIENCY_LATERALSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Efficiency report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Time to hire</TippyLI>
            <TippyLI>Decline reason</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  SCHOOLSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>School report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>KS5 average grades</TippyLI>
            <TippyLI>KS5 school type</TippyLI>
            <TippyLI>KS4 school type</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  UNIVERSITYSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>University report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Universities</TippyLI>
            <TippyLI>University - Russell Group/Non-Russell group</TippyLI>
            <TippyLI>Degree type (Law/STEM/Other)</TippyLI>
            <TippyLI>Degree classification</TippyLI>
            <TippyLI>Year of study</TippyLI>
            <TippyLI>Oxbridge college</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  UNIVERSITYSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>University report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Universities</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  MARKETINGSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Marketing report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Apps, interviews, offers, hires by source</TippyLI>
            <TippyLI>Apps, interviews, offers, hires by supporting org</TippyLI>
            <TippyLI>Gender breakdown</TippyLI>
            <TippyLI>Ethnicity breakdown</TippyLI>
            <TippyLI>Socioeconomic status breakdown</TippyLI>
            <TippyLI>Disability status breakdown</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  MARKETINGSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>Marketing report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Apps, interviews, offers, hires by source</TippyLI>
            <TippyLI>Apps, interviews, offers, hires by supporting org</TippyLI>
            <TippyLI>Gender breakdown</TippyLI>
            <TippyLI>Disability status breakdown</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  EVENTSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Events report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Event attendance</TippyLI>
            <TippyLI>Event to app conversion</TippyLI>
            <TippyLI>App to hire conversion</TippyLI>
            <TippyLI>Event attendance by university</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  EVENTSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>Events report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Event attendance</TippyLI>
            <TippyLI>Event to app conversion</TippyLI>
            <TippyLI>App to hire conversion</TippyLI>
            <TippyLI>Event attendance by university</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  REJECTIONSNAPSHOT: (
    <div>
      <div className={"tippy-title"}>Rejection reasons report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Rejection reasons</TippyLI>
            <TippyLI>Gender breakdown</TippyLI>
            <TippyLI>Ethnicity breakdown</TippyLI>
            <TippyLI>Socioeconomic status breakdown</TippyLI>
            <TippyLI>Disability status breakdown</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  REJECTIONSNAPSHOTGLOBAL: (
    <div>
      <div className={"tippy-title"}>Rejection reasons report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Rejection reasons</TippyLI>
            <TippyLI>Gender breakdown</TippyLI>
            <TippyLI>Disability status breakdown</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  CONTEXTUALADVERSE: (
    <div>
      <div className={"tippy-title"}>Contextual report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Total CRS flags</TippyLI>
            <TippyLI>CRS flag type</TippyLI>
            <TippyLI>School percentile</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITYADVERSE: (
    <div>
      <div className={"tippy-title"}>Diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>1+ flags</TippyLI>
            <TippyLI>Disability</TippyLI>
            <TippyLI>Sexual orientation</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  DIVERSITYADVERSELATERAL: (
    <div>
      <div className={"tippy-title"}>Diversity report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>Gender</TippyLI>
            <TippyLI>Ethnicity</TippyLI>
            <TippyLI>Disability</TippyLI>
            <TippyLI>Sexual orientation</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  SCHOOLADVERSE: (
    <div>
      <div className={"tippy-title"}>School report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>KS5 school type</TippyLI>
            <TippyLI>KS4 school type</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  UNIVERSITYADVERSE: (
    <div>
      <div className={"tippy-title"}>University report</div>
      <div className={"tippy-content"}>
        <p>
          <TippyUL>
            <TippyLI>University - Russell Group/Non-Russell group</TippyLI>
            <TippyLI>Degree type (Law/STEM/Other)</TippyLI>
          </TippyUL>
        </p>
      </div>
    </div>
  ),
  CALCULATION_TYPE_GRADE: (
    <div>
      <div className={"tippy-title"}>Grade controlled</div>
      <div className={"tippy-content"}>
        <p>
          This method calculates the weighted average, adjusting the figures to
          account for the number of applications with different KS5 grades.
        </p>
      </div>
    </div>
  ),
  CALCULATION_TYPE_RAW: (
    <div>
      <div className={"tippy-title"}>Raw</div>
      <div className={"tippy-content"}>
        <p>
          This method calculates a simple average, without any weighted
          adjustments.
        </p>
      </div>
    </div>
  ),
  ROLE_CLOSE_DATE: (
    <div>
      <div className={"tippy-title"}>Close date</div>
      <div className={"tippy-content"}>
        <p>
          We advise setting your close date and time to be during UK GMT working
          hours, and outside UK bank holidays. This ensures an adequate response
          time for candidate queries.
        </p>
      </div>
    </div>
  ),
  PHONETIC_SPELLING: (
    <div>
      <div className={"tippy-content"}>
        <p>
          As part of our commitment to creating an inclusive workplace
          experience, we are focused on achieving a better appreciation and
          understanding of the significance of each other's given names.
          <br />
          <br />
          We encourage all people who work here to incorporate the phonetic
          spell of their names into their email signatures if it would be
          beneficial to them to do so. We want to extend this opportunity to our
          candidates.
          <br />
          <br />
          If you need guidance on phonetic pronunciation,{" "}
          <a
            href="https://mynameis.raceequalitymatters.com/"
            target="_blank"
            rel="noreferrer"
          >
            Race Equality Matters
          </a>{" "}
          has a useful online translation tool.
        </p>
      </div>
    </div>
  ),
}

export const TooltipsContent = ({ name }) => {
  return Tooltips[name]
}

export default TooltipsContent
